const RowComponent = {
    templateUrl: '/formViewer/structure/row/row.tpl.html',
    controller: 'rowController',
    bindings: {
        row: '<'
    }
};

angular.module('umFormViewer')
    .component('uiRow', RowComponent);

